module.exports = __webpack_public_path__ + "account/img/100.a3ddb2d5.png";